/**
 * @Description 钉钉相关接口
 */
import { post } from '@/common/request/index';


/**
 * 免登接口
 * https://yapi.lanhanba.com/project/378/interface/api/78000
 */
export function dingTalkOauthLogin(params?: any) {
  return post('/dingTalkOauth/login', { ...params }, {
    isMirage: true
  });
}
